export default __webpack_public_path__ + "static/media/login-variant.aba89a5a.svg";